export default "__VITE_ASSET__C24B1cPb__"